import React, { useCallback, useEffect, useState } from 'react';

import CN from 'components/experiment/hooks/HooksPage.module.scss';
import Button from 'components/form/Button.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';

const L = logger('EffectExample');

const EffectExample = ({ counter }) => {
  const [localCounter, setLocalCounter] = useState(counter);

  const bump = useCallback(() => void setLocalCounter(localCounter + 1), [localCounter]);
  const reset = useCallback(() => void setLocalCounter(0), []);

  useEffect(() => void setLocalCounter(-777), []);

  L.debug('()', { localCounter, counter });

  return (
    <div data-bem="EffectExample" className={CN.col}>
      <p>
        counter: {fromAnyToTrimmed(counter)}
        <br />
        localCounter: {fromAnyToTrimmed(localCounter)}
      </p>
      <div className={CN.row}>
        <Button onClick={bump}  variant="primary" casing="dialog" >
          bump
        </Button>
        <Button onClick={reset} variant="alert">
          reset
        </Button>
      </div>
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default EffectExample;
